import { twClassMerge } from '@healthhub/react-ui';
import { Link } from 'react-router';

import { PortalOutlinedNotificationIcon } from '@shared/assets-icon';
import { INBOX_NOTIFICATIONS_PATH, INBOX_PUBLIC_NOTIFICATIONS_PATH } from '@shared/constants/paths';
import useIsAuthenticated from '@shared/hooks/useIsAuthenticated';
import { useGetInboxMessageUnreadCountQuery } from '@shared/services/inbox';

interface InboxNotificationProps {
  className?: string;
}

const InboxNotification = ({ className }: InboxNotificationProps) => {
  const { isAuthenticated } = useIsAuthenticated();
  const { data } = useGetInboxMessageUnreadCountQuery(undefined, { skip: !isAuthenticated });

  const hasUnreadMessages = (data?.Count ?? 0) > 0;

  return (
    <Link
      className={twClassMerge('flex items-center gap-1 w-13 lg:w-auto justify-center', className)}
      to={isAuthenticated ? INBOX_NOTIFICATIONS_PATH : INBOX_PUBLIC_NOTIFICATIONS_PATH}
    >
      <div className="relative">
        <PortalOutlinedNotificationIcon className="size-6 shrink-0" />
        {!!hasUnreadMessages && <div className="absolute right-0.5 top-0 size-2 rounded-full bg-[#E20808]" />}
      </div>
      <span className="hidden text-lg font-medium text-primary-green-4 lg:inline" lang="en">
        Inbox
      </span>
    </Link>
  );
};

export default InboxNotification;
